import React, { useCallback } from 'react';
import { Box, Button, Grid, Typography } from '@material-ui/core';
import CardInfoItem from '../../atoms/CardInfoItem/CardInfoItem';
import ImageGallery from '../ImageGallery/ImageGallery';
import { CourierRegType } from '../../../api/couriers';
import { CourierInfoProps } from './index';

export const CourierInfo: React.FC<CourierInfoProps> = ({
    user,
    courier,
    photos,
    type,
    handleEdit,
}: CourierInfoProps) => {
    const handleEditClick = useCallback(() => {
        if (handleEdit) {
            handleEdit(courier);
        }
    }, [courier, handleEdit]);
    return (
        <>
            <Box display="flex">
                <Typography variant="h4">Основная информация</Typography>
                {type === CourierRegType.Activation && (
                    <Button
                        style={{ marginLeft: 'auto', marginTop: '-5px', marginRight: '20px' }}
                        color="primary"
                        onClick={handleEditClick}
                        variant="contained"
                    >
                        Редактировать данные курьера
                    </Button>
                )}
            </Box>
            <Box marginTop={2} marginLeft={3}>
                <Grid container spacing={3}>
                    <Grid item xs>
                        <CardInfoItem title="ФИО" body={[user?.last_name, user?.first_name]} />
                        <CardInfoItem title="Телефон" body={user?.phone_number} />
                        <CardInfoItem title="Дата регистрации" body={user?.date_created} />
                        <CardInfoItem title="ИИН" body={user?.idn} />
                        {courier?.card_number && (
                            <CardInfoItem
                                title="Номер счета карты (IBAN)"
                                body={courier?.card_number}
                            />
                        )}
                    </Grid>
                    {type !== CourierRegType.New && (
                        <Grid item xs>
                            <CardInfoItem
                                title="Вид документа"
                                body={courier?.document_type?.description}
                            />
                            <CardInfoItem title="Номер документа" body={courier?.passport_number} />
                            <CardInfoItem title="Дата выдачи" body={courier?.passport_date || ''} />
                            <CardInfoItem title="Кем выдано" body={courier?.passport_issued_by} />
                            {courier?.fact_address && (
                                <CardInfoItem
                                    title="Фактический адрес проживания"
                                    body={courier?.fact_address}
                                />
                            )}
                        </Grid>
                    )}
                    <Grid item xs>
                        <CardInfoItem
                            title="Налоговые льготы"
                            body={courier?.is_beneficiary ? 'Да' : 'Нет'}
                        />
                        <CardInfoItem title="Регион" body={user?.region?.description} />
                        <CardInfoItem title="Почта" body={user?.email} />
                        {user?.username && <CardInfoItem title="Логин" body={user?.username} />}
                        {courier?.personnel_number && (
                            <CardInfoItem
                                title="Табельный номер"
                                body={courier?.personnel_number}
                            />
                        )}
                    </Grid>
                    {type === CourierRegType.New && <Grid item xs></Grid>}
                </Grid>
            </Box>
            <Box marginTop={2}>
                <Typography variant="h4">Фотографии</Typography>
                <Box marginTop={3} margin={3}>
                    <ImageGallery photos={photos} />
                </Box>
            </Box>
        </>
    );
};

export default CourierInfo;
